import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";

import * as serviceWorker from "./serviceWorker";
import { createBrowserHistory } from "history";

//Addition for AWS S3
const history = createBrowserHistory();
const path = (/#!(\/.*)$/.exec(document.location.hash) || [])[1];
if (path) {
  history.replace(path);
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
